import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },

  twoImages: {
    display: 'grid',
    gridRowGap: '0.75rem',
    gridColumnGap: '0.75rem',
    gridTemplateRows: 'repeat(1, 200px)',
    gridTemplateColumns: 'repeat(2, 1fr)',

    [theme.breakpoints.down('lg')]: {
      gridTemplateRows: 'repeat(1, 150px)'
    }
  },

  showMore: {
    height: '100px',
    flexBasis: '49%',
    background: theme.palette.divider,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  setWidth: {
    width: '100%',
    display: 'grid',
    gridRowGap: '0.75rem',
    gridColumnGap: '0.75rem',
    gridTemplateRows: 'repeat(2, 200px)',
    gridTemplateColumns: 'repeat(2, 1fr)',

    [theme.breakpoints.down('lg')]: {
      gridTemplateRows: 'repeat(2, 150px)'
    }
  },

  parent: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  grid: {
    gridTemplateRows: 'repeat(3, 200px)',

    [theme.breakpoints.down('lg')]: {
      gridTemplateRows: 'repeat(3, 150px)'
    }
  }
}))

export default useStyles
